import { Box, Grid } from "@mui/material";
import React, { Component } from "react";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import CtDtp from "./CustomTool/CtDtp";
import TableList from "./CustomTool/TableList";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { withRouter } from "../HOC/withRouter";
import { Edit, Delete, LocalShipping } from "@mui/icons-material";
import VehicleUnload from "./VehicleUnload";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import Progress from "./CustomTool/Progress";

class VehicleList extends Component {
  state = {
    CompanyName: [],
    VechileNo: [],
    DriverName: [],
    rows: [
      {
        loadingsrno: "1",
        loadingdate: "29-04-2023",
        companyname: "",
        vehicleno: "",
        drivername: "",
        totalamount: "",
        unloaddate: "",
        totalunloadamount: "",
      },
    ],
    rowsCount: 1,
    rowsPerPage: 10,
    counter: 0,
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "loadingsrno", label: "Loading Sr. No." },
      { id: "loadingdate", label: "Loading Date" },
      { id: "companyname", label: "Company Name" },
      { id: "vehicleno", label: "Vehicle No." },
      { id: "drivername", label: "Driver Name" },
      { id: "totalamount", label: "Total Amount" },
      { id: "unloaddate", label: "Unload Date" },
      { id: "totalunloadamount", label: "Total Unload Amount" },
    ],
    keyColumn: [
      "loadingsrno",
      "loadingdate",
      "companyname",
      "vehicleno",
      "drivername",
      "totalamount",
      "unloaddate",
      "totalunloadamount",
    ],
    formData: {
      FromDate: "",
      ToDate: "",
    },
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "VehicleList",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "VehicleList",
        actionType: "AlertResponsive",
      },
      {
        name: "Unload",
        icon: <LocalShipping />,
        link: "VehicleUnload",
        actionType: "AlertResponsive",
      },
    ],
    searchData: {
      loadingsrno: "",
      loadingdate: "",
      companyname: "",
      vehicleno: "",
      drivername: "",
      totalamount: "",
      unloaddate: "",
      totalunloadamount: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    ARD: null,
    dataLoadStatus: true,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Vehicle List";
    this.props.setActiveMenu("VehicleList");
    this.setSearchColumns();
    this.props.verifyUserID(
      this.getInfo,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region Handle
  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.loadingsrno.length === 0 ||
            (row["loadingsrno"] &&
              row["loadingsrno"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.loadingsrno.toLowerCase()))) &&
          (this.state.searchData.loadingdate.length === 0 ||
            (row["loadingdate"] &&
              row["loadingdate"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.loadingdate.toLowerCase()))) &&
          (this.state.searchData.companyname === "ALL" ||
            this.state.searchData.companyname === row["companyname"]) &&
          (this.state.searchData.vehicleno === "ALL" ||
            this.state.searchData.vehicleno === row["vehicleno"]) &&
          (this.state.searchData.drivername === "ALL" ||
            this.state.searchData.drivername === row["drivername"]) &&
          (this.state.searchData.totalamount.length === 0 ||
            (row["totalamount"] &&
              row["totalamount"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.totalamount.toLowerCase()))) &&
          (this.state.searchData.unloaddate.length === 0 ||
            (row["unloaddate"] &&
              row["unloaddate"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.unloaddate.toLowerCase()))) &&
          (this.state.searchData.totalunloadamount.length === 0 ||
            (row["totalunloadamount"] &&
              row["totalunloadamount"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.totalunloadamount.toLowerCase()
                )))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };
  handleOnSearchInputChange = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen);
        // console.log(this.state.searchData)
      }
    );
  };

  handleARDonActionClick = (row) => {
    console.log("row");
    const loadingsrno = row.loadingsrno,
      FromDate = row.loadingdate,
      ToDate = row.unloaddate,
      companyname = row.companyname,
      actionName = row.actionName;
    if (actionName === "Edit") {
      this.setState({
        formData: {
          ...this.state.formData,
          FromDate,
          ToDate,
        },
      });
    } else if (actionName === "Delete") {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete: '" +
              companyname +
              "' With Sr No. : '" +
              loadingsrno +
              "'?"
            }
            alertMessage=""
            // handleOnClickYes={() => {
            //     return this.deleteMember(bint_memberid)
            // }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else if (actionName === "Unload") {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            // alertTitle={"Vehicle Unload"}
            alertMessage={<VehicleUnload />}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };
  //#endregion Handle

  //#region function

  handleOnNewEntryClick = () => {
    {
      this.props.navigateTo("VehicleLoadEntry");
    }
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "loadingsrno",
        label: "Loading Sr. No.",
        value: this.state.searchData.loadingsrno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        label: "Loading Date",
        width: "120",
      },
      {
        cType: "CtTxt",
        id: "companyname",
        items: this.state.CompanyName,
        label: "Company Name",
        value: this.state.searchData.companyname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "vehicleno",
        items: this.state.VechileNo,
        label: "Vechile No.",
        value: this.state.searchData.vehicleno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "drivername",
        items: this.state.DriverName,
        label: "Driver Name",
        value: this.state.searchData.drivername,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "totalamount",
        label: "Total Amount",
        value: this.state.searchData.totalamount,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        label: "Unload Date",
        width: "120",
      },
      {
        cType: "CtTxt",
        id: "totalunloadamount",
        label: "Total Unload Amount",
        value: this.state.searchData.totalunloadamount,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      }
    );
    this.setState({ searchColumns });
  };

  //#endregion function

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Vehicle Load - Unload List</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={1}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtDtp
                  id="dtpFromDate"
                  label="From Date"
                  width="150"
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpToDate"
                  label="To Date"
                  width="150"
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtBtn label="Save" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          marginTop={2}
        >
          <TableList
            columns={this.state.columns}
            counter={this.state.counter}
            rows={rows}
            rowsCount={rowsCount}
            headRowFontColor="#ffffff"
            rowsPerPage={this.state.rowsPerPage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            handleOnActionClick={this.handleARDonActionClick}
            actionList={this.state.actionList}
            keyColumn={this.state.keyColumn}
            handleOnSearchChange={this.handleOnSearchChange}
            searchColumns={this.state.searchColumns}
            searchData={this.state.searchData}
            provideSearch={true}
            handleOnNewEntryClick={this.handleOnNewEntryClick}
            toolTipNewEntry="Vehicle Load Entry"
          />
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(withRouter(VehicleList)));
